import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useLanguage } from '../../../context/LanguageContext';
import './Contact.css';

const Contact = () => {
  const { t } = useLanguage();

  const contactInfo = [
    {
      icon: <MapPin className="h-8 w-8" />,
      title: t('contact.visitUs.title'),
      details: [t('contact.visitUs.line1'), t('contact.visitUs.line2'), t('contact.visitUs.line3')]
    },
    {
      icon: <Phone className="h-8 w-8" />,
      title: t('contact.callUs.title'),
      details: [t('contact.callUs.line1'), t('contact.callUs.line2'), t('contact.callUs.line3')]
    },
    {
      icon: <Mail className="h-8 w-8" />,
      title: t('contact.emailUs.title'),
      details: [t('contact.emailUs.line1'), t('contact.emailUs.line3')]
    }
  ];

  return (
    <section id="contact" className="py-20 text-white contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-xl text-brand-light">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {contactInfo.map((contact, idx) => (
            <div key={idx} className="bg-white bg-opacity-10 backdrop-blur-lg p-8 rounded-xl text-center hover:bg-opacity-20 transition-colors border border-white border-opacity-20">
              <div className="bg-brand-primary p-4 rounded-lg inline-block mb-4 shadow-lg">
                {contact.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4">{contact.title}</h3>
              {contact.details.map((detail, i) => (
                <p key={i} className="text-brand-light">{detail}</p>
              ))}
            </div>
          ))}
        </div>

        {/* Map Section */}
        <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl overflow-hidden shadow-2xl border border-white border-opacity-20">
          <div className="p-6 border-b border-white border-opacity-20">
            <h3 className="text-2xl font-bold text-white flex items-center gap-3">
              <MapPin className="h-6 w-6 text-brand-light" />
              {t('contact.mapTitle')}
            </h3>
            <p className="text-brand-light mt-2">{t('contact.mapAddress')}</p>
          </div>
          <div className="w-full h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3908.993434983287!2d104.93786077422318!3d11.552327988647543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310956d2a2d70f1d%3A0xea84a6a9241db2f6!2sMorgan%20Tower!5e0!3m2!1sen!2ssg!4v1786349730268!5m2!1sen!2ssg"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Morgan Tower Location"
            ></iframe>
          </div>
          <div className="p-6 bg-white bg-opacity-5">
            <a
              href="https://www.google.com/maps/search/?api=1&query=Morgan+Tower+Phnom+Penh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-brand-primary text-white px-6 py-3 rounded-lg hover:bg-brand-dark transition-all font-semibold shadow-lg"
            >
              <MapPin className="h-5 w-5" />
              {t('contact.openInMaps')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
